import { LitElement, html } from 'lit';

import dispatchCustomEvent from '../../utils/dispatch-custom-event';
import translate from '../../utils/webcomponents/translate';

import accountEvents from './account-events';

class AccountSubscriptionsEditForm extends LitElement {
	disconnectedCallback() {
		this.removeEventListener('submit', this.onSubmit);

		super.disconnectedCallback();
	}

	async firstUpdated() {
		this.addEventListener('submit', this.onSubmit);
	}

	render() {
		const textDisableBroker = translate(
			'account',
			'disableBrokerText',
			'Are you sure you want to disable the preferred broker functionality and unsubscribe from our updates on BNP services and products?',
		);
		const labelConfirm = translate('account', 'confirmTurnOff', 'Yes, I want to turn this off');
		const labelCancel = translate('account', 'cancel', 'Cancel');

		return html`
			<form class="form trailer-reset">
				<p>${textDisableBroker}</p>
				<div class="form__footer form__footer--centered">
					<button
						type="submit"
						class="button"
					>
						${labelConfirm}
					</button>
					<button
						type="button"
						class="button button--ghost js-close"
					>
						${labelCancel}
					</button>
				</div>
			</form>
		`;
	}

	onSubmit(e) {
		e.preventDefault();

		dispatchCustomEvent(document.body, accountEvents.ITEM_EDIT_ALLOWS_CONTACT, { isChecked: false });

		this.triggerClose();
	}

	triggerClose() {
		const el = this.querySelector('.js-close');

		if (el) {
			el.click();
		}
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-account-subscriptions-edit-form', AccountSubscriptionsEditForm);

export default AccountSubscriptionsEditForm;

